import ReactOnRails from 'react-on-rails';
// We lack an index.js file
// Importing our top level stylesheet here
import '../import.scss';

import { ChevronDown as IconChevronDown } from 'react-feather';

import RetakeLessonRoot from 'components/lesson/RetakeLesson/RetakeLessonRoot';
import QuestionDetails from 'components/shared/QuestionDetails';
import PartnerFeedbackWrapper from 'components/ReportCard/RolePlay/PartnerFeedbackWrapper';
import PartnerFeedbackRoot from 'components/ReportCard/RolePlay/PartnerFeedbackRoot';
import PartnerFeedbackReportMobile from 'components/ReportCard/RolePlay/PartnerFeedbackReportMobile';
import PartnerFeedbackReportDesktop from 'components/ReportCard/RolePlay/PartnerFeedbackReportDesktop';
import PartnerGuideRoot from 'components/Practice/RolePlay/PartnerGuide/PartnerGuideRoot';
import Progress from 'components/ReportCard/Progress';
import LessonRecap from 'components/ReportCard/LessonRecap';
import AddEvaluators from 'components/people/AddEvaluators';
import GlobalSkillsSettings from 'components/settings/GlobalSkillsSettings';
import JourneyBuilder from 'components/JourneyBuilder/root';
import InformationSidebar from 'components/JourneyBuilder/InformationSidebar/InformationSidebar';

import { withPage } from './components/Application/Page';
import { withModule } from './components/Application/Module';

import * as InPersonTraining from './components/InPersonTraining';
import * as LessonAskTheExpert from './components/lesson/AskTheExpert';
import LessonsCompleteRoot from './components/lesson/LessonsComplete/LessonsCompleteRoot';
import * as LessonOverview from './components/LessonOverview';
import AdvancedContentSearchRoot from './components/AdvancedContentSearchRoot';
import AllAttempts from './components/OnDemandPractice/Learner/PreviousAttempts/AllAttempts';
import ApiKeys from './components/settings/Integrations/ApiKeys';
import AppSwitcher from './components/shared/AppSwitcher';
import AnswerFeedbackRoot from './components/lesson/AnswerFeedback/AnswerFeedbackRoot';
import AnalyzerRightsContents from './components/AnalyzerRightsContents';
import ArchiveRoot from './components/archives/root';
import AssignModal from './components/AssignModal';
import AssociatedSkills from './components/Skills/Lesson/AssociatedSkills';
import AudioQuestion from './components/Practice/Audio/AudioQuestion';
import BlankSlate from './components/_shared/blank_slate/_blank_slate.js';
import BulkImportCanceled from './components/BulkImportCanceled';
import CertificateRoot from './components/Certificate/CertificateRoot';
import ChatPracticeQuestion from './components/ChatPractice/ChatPracticeQuestion';
import ChatDetails from './components/ReportCard/Chat/ChatDetails';
import CogMenu from './components/CogMenu';
import CompletedCertifications from './components/Certifications/index';
import ConditionalList from './components/shared/ConditionalList';
import ContentIndexRoot from './components/content/root';
import ContentLibraryRoot from './components/ContentLibrary';
import ConversationLearner from './components/Questions/ConversationLearner';
import ConversationOverview from './components/Questions/ConversationOverview';
import CriteriaList from './components/VideoResponse/Grading/CriteriaList';
import * as Demonstration from './components/DemonstrationViewer';
import DemuxAppsIntegrationSettings from './components/settings/Integrations/Demux';
import DigestPreferences from './components/settings/DigestPreferences';
import DisplayPermissions from './components/Roles/modals/DisplayPermissions';
import DocumentViewer from './components/DocumentViewer';
import EditGroup from './components/groups/EditGroup';
import EditorRoot from './components/editor/root';
import EmailPracticeQuestion from './components/EmailPractice/EmailPracticeQuestion';
import Embed from './components/ViewElements/Embed';
import ErrorPage from './components/shared/ErrorPage';
import ExportAllPeopleButton from './components/people/ExportAllPeopleButton';
import Gong from './components/ViewElements/Gong';
import FreeResponse from './components/ViewElements/FreeResponse';
import Flipcard from './components/ViewElements/Flipcard';
import GradeBookRoot from './components/GradeBookRoot';
import GradePendingNotice from './components/GradePending/GradePendingNotice';
import GradingStationPreviousComments from './components/GradingStation/GradingStationPreviousComments';
import HighFiveShareableLink from './components/shared/HighFiveShareableLink';
import IlosIntegrationSettings from './components/settings/Integrations/Ilos';
import Image from './components/ViewElements/Image';
import ImageLibrary from './components/ImageLibrary';
import ImagePreview from './components/shared/ImagePreview';
import ImageUpload from './components/shared/ImageUpload';
import InfoTooltip from './components/shared/InfoTooltip';
import EditPermissionNeeded from './components/shared/EditPermissionNeeded';
import EditTag from './components/Tags/EditTag';
import InsightsRoot from './components/insights/root';
import InsightsV2 from './components/insights/v2';
import JourneyViewer from './components/JourneyViewer/root';
import JourneyReporting from './components/JourneyReporting/root';
import JourneyReportCard from './components/JourneyReporting/JourneyReportCard';
import KnowledgeCheckNew from './components/Questions/KnowledgeCheck/KnowledgeCheckNew';
import KnowledgeCheckShow from './components/Questions/KnowledgeCheck/KnowledgeCheckShow';
import ChangeLanguage from './components/settings/ChangeLanguage';
import LaunchScormError from './components/content/LaunchScormError';
import LessonTitle from './components/lesson/LessonHeader/LessonTitle';
import Learn from './components/Learn';
import LearnerOverview from './components/OnDemandPractice/Creator/LearnerOverview/index.jsx';
import LearnerSectionStats from './components/ReportCard/LearnerSectionStats.jsx';
import LessonEngagement from './components/lesson_analytics/LessonEngagement';
import LessonEvent from './components/LessonEvent';
import LessonHeader from './components/lesson/LessonHeader';
import LessonMicroFeedback from './components/lesson/MicroFeedback';
import LessonNavigation from './components/lesson/LessonNavigation';
import LessonProgressProvider from './components/LessonProgress/LessonProgressProvider';
import LibraryTopic from './components/shared/LibraryTopic';
import MatchingShow from './components/Questions/MatchingQuestion/MatchingShow';
import MediaRecording from './components/lesson/MediaRecording';
import MediaResponseQuestion from './components/shared/MediaResponse/MediaResponseQuestion';
import MultipleChoiceSurvey from './components/ViewElements/MultipleChoiceSurvey';
import MultipleSelect from './components/ViewElements/MultipleSelect';
import Navbar from './components/Navbar';
import Notice from './components/ui/Notice/Notice';
import NotificationSubscriptions from './components/NotificationSubscriptions';
import NotificationSubscriptionsTab from './components/settings/tabs/NotificationSubscriptionsTab';
import OnDemandPracticeAttempts from './components/OnDemandPractice/Creator/OnDemandPracticeAttempts';
import OnDemandPracticeEditor from './components/OnDemandPractice/Creator/OnDemandPracticeEditor';
import OnDemandPracticeFeedbackGiving from './components/OnDemandPractice/FeedbackGiver/OnDemandPracticeFeedbackGiving';
import OnDemandPracticeOverview from './components/OnDemandPractice/Creator/OnDemandPracticeOverview';
import OnDemandPracticeRouter from './components/OnDemandPractice/Learner/OnDemandPracticeRouter';
import OnDemandPracticeScenario from './components/OnDemandPractice/Learner/OnDemandPracticeScenario';
import OnDemandPracticeFeedbackOverview from './components/OnDemandPractice/Learner/OnDemandPracticeFeedbackOverview';
import OnDemandPracticeRequestFeedback from './components/OnDemandPractice/Learner/OnDemandPracticeRequestFeedback';
import OpenDownload from './components/Questions/UploadResponseQuestion/OpenDownload';
import Pagination from './components/shared/pagination';
import PartnerFeedbackSummaryRoot from './components/Practice/RolePlay/Feedback/PartnerFeedbackSummaryRoot';
import PasswordChange from './components/settings/MyAccount/PasswordChange';
import PathBuilder from './components/PathBuilder/root';
import PathViewer from './components/PathViewer/root';
import PeopleAdvancedRoot from './components/people/advanced/root';
import PracticeQuestion from './components/Practice/PracticeQuestion';
import PracticeQuestionInsights from './components/insights/practice/PracticeQuestionInsights';
import ProgressBar from './components/LessonProgress/ProgressBar';
import QuestionElementPrompt from './components/Questions/shared/QuestionElementPrompt';
import QuestionPrompt from './components/Practice/Learner/QuestionPrompt';
import RadialProgress from './components/_shared/radial_progress.js';
import RelatedUrlsIndex from './components/chrome_extension/RelatedUrlsIndex';
import WebWidgetIndex from './components/chrome_extension/WebWidgetIndex';
import ReminderModal from './components/ReminderModal';
import RepeatablePracticeQuestion from './components/Practice/RepeatablePracticeQuestion';
import ResetPassword from './components/shared/ResetPassword/index';
import Reveal from './components/ViewElements/Reveal';
import Roles from './components/Roles';
import RolePlay from './components/Practice/RolePlay';
import SalesforceIntegrationSettings from './components/settings/Integrations/Salesforce';
import SaveLessonAsTemplate from './components/content/SaveLessonAsTemplate';
import SettingsReportCardHeader from './components/settings/GlobalLessonSettings/SettingsReportCardHeader';
import ScormCopyContentModal from './components/content/ScormCopyContentModal';
import ScormMultipleDownload from './components/content/ScormMultipleDownload';
import ScreenRecordingQuestion from './components/Practice/ScreenRecording/ScreenRecordingQuestion';
import SharableRecordingLinkContainer from './components/VideoResponse/SharableRecordingLinkContainer';
import ShareToCompany from './components/content/ShareToCompany';
import SkillsLibrary from './components/Skills';
import SortingQuestion from './components/Questions/Sorting/SortingQuestion';
import GlobalTimeSelect from './components/shared/GlobalTimeSelect';
import GlobalTimeZoneSelect from './components/shared/GlobalTimeZone';
import TagsIndex from './components/Tags';
import TagImage from './components/TagImage';
import TaskBuilder from './components/JourneyBuilder/Content/TaskBuilder';
import TemplateGalleryRoot from './components/TemplateGallery';
import TextView from './components/ViewElements/TextView';
import TicketHandlingPracticeQuestion from './components/TicketHandlingPractice/TicketHandlingPracticeQuestion';
import TriggerBuilder from './components/TriggerBuilder';
import TriggersContainer from './components/Triggers';
import SeismicContent from './components/ViewElements/SeismicContent';
import UploadResponseQuestion from './components/Questions/UploadResponseQuestion/UploadResponseQuestion';
import GradingStationRoot from './components/GradingStation/Root';
import VideoResponse from './components/VideoResponse/Grading/VideoResponse';
import VideoResponseQuestion from './components/VideoResponse/Learning/VideoResponseQuestion';
import VideoThumbnail from './components/VideoResponse/Grading/VideoThumbnail';
import WorkspacesIndex from './components/Workspaces/WorkspacesIndex';
import ZendeskPracticeQuestion from './components/TicketHandlingPractice/Zendesk/ZendeskPracticeQuestion';
import * as Settings from './components/settings';
import SettingsCustomization from './components/settings/SettingsCustomization';
import ZendeskIntegrationSettings from './components/settings/Integrations/Zendesk';
import AssignmentIncomplete from './components/AssignmentIncomplete';
import UserProgress from './components/AssignmentIncomplete/UserProgress';

const pageComponents = {
  AdvancedContentSearchRoot,
  ArchiveRoot,
  CertificateRoot,
  GradingStationPreviousComments,
  GradingStationRoot,
  InPersonTrainingNewEvent: InPersonTraining.NewEvent,
  InPersonTrainingEventsIndex: InPersonTraining.EventsIndex,
  InPersonTrainingInviteUsers: InPersonTraining.InviteUsers,
  InPersonTrainingEventsDashboard: InPersonTraining.EventsDashboard,
  InPersonTrainingEventOverview: InPersonTraining.EventOverviewRoot,
  InPersonTrainingEventRegistrationOverview:
    InPersonTraining.EventRegistrationOverview,
  InPersonTrainingEventAttendingRegistration:
    InPersonTraining.EventRegistration,
  JourneyViewer,
  JourneyBuilder,
  JourneyReporting,
  JourneyReportCard,
  LessonsCompleteRoot,
  OnDemandPracticeRouter,
  PartnerGuideRoot,
  PathViewer,
  RelatedUrlsIndex,
  RetakeLessonRoot,
  SkillsLibrary,
  WebWidgetIndex,
};

const components = {
  AddEvaluators,
  AllAttempts,
  AnalyzerRightsContents,
  AnswerFeedbackRoot,
  ApiKeys,
  AppSwitcher,
  AssignModal,
  AssociatedSkills,
  AudioQuestion,
  BlankSlate,
  BulkImportCanceled,
  ChangeLanguage,
  ChatDetails,
  ChatPracticeQuestion,
  CogMenu,
  CompletedCertifications,
  ConditionalList,
  ContentIndexRoot,
  ContentLibraryRoot,
  ConversationLearner,
  ConversationOverview,
  CriteriaList,
  DemonstrationViewer: Demonstration.DemonstrationViewer,
  DemuxAppsIntegrationSettings,
  DigestPreferences,
  DisplayPermissions,
  DocumentViewer,
  EditGroup,
  EditorRoot,
  EditTag,
  EditPermissionNeeded,
  EmailPracticeQuestion,
  Embed,
  ErrorPage,
  ExportAllPeopleButton,
  Flipcard,
  FreeResponse,
  GlobalSkillsSettings,
  GlobalTimeSelect,
  GlobalTimeZoneSelect,
  Gong,
  GradeBookRoot,
  GradePendingNotice,
  HighFiveShareableLink,
  IconChevronDown,
  IlosIntegrationSettings,
  Image,
  ImageLibrary,
  ImagePreview,
  ImageUpload,
  InformationSidebar,
  InfoTooltip,
  InsightsRoot,
  InsightsV2,
  KnowledgeCheckNew,
  KnowledgeCheckShow,
  LaunchScormError,
  Learn,
  LearnerOverview,
  LearnerSectionStats,
  LessonAskTheExpertMobile: LessonAskTheExpert.Mobile,
  LessonAskTheExpertDesktop: LessonAskTheExpert.Desktop,
  LessonEngagement,
  LessonEvent,
  LessonHeader,
  LessonMicroFeedback,
  LessonNavigation,
  LessonOverviewAssignmentSummary: LessonOverview.AssignmentSummary,
  LessonOverviewCompletionPercentage: LessonOverview.CompletionPercentage,
  LessonOverviewConversationMetricsTable:
    LessonOverview.ConversationMetricsTable,
  LessonOverviewDraftPublishSuccess: LessonOverview.DraftPublishSuccess,
  LessonOverviewFeaturedContent: LessonOverview.FeatureContent,
  LessonOverviewLearnerRatings: LessonOverview.LearnerRatings,
  LessonOverviewLessonDistributors: LessonOverview.LessonDistributors,
  LessonOverviewLessonExpert: LessonOverview.LessonExpert,
  LessonOverviewLessonGraders: LessonOverview.LessonGraders,
  LessonOverviewLessonOverviewLayout: LessonOverview.LessonOverviewLayout,
  LessonOverviewLessonOwnership: LessonOverview.LessonOwnership,
  LessonOverviewLessonRecap: LessonOverview.LessonRecap,
  LessonOverviewLessonVersionModal: LessonOverview.LessonVersionModal,
  LessonOverviewNonGradedQuestionPerformance:
    LessonOverview.NonGradedQuestionPerformance,
  LessonOverviewPracticeInsights: LessonOverview.PracticeInsights,
  LessonOverviewScorableQuestions: LessonOverview.ScorableQuestions,
  LessonOverviewScormAnalytics: LessonOverview.ScormAnalytics,
  LessonOverviewTaggings: LessonOverview.Taggings,
  LessonOverviewWorkspace: LessonOverview.Workspace,
  LessonProgressProvider,
  LessonRecap,
  LessonTitle,
  LibraryTopic,
  MatchingShow,
  MediaRecording,
  MediaResponseQuestion,
  MultipleChoiceSurvey,
  MultipleSelect,
  Navbar,
  Notice,
  NotificationSubscriptions,
  NotificationSubscriptionsTab,
  OnDemandPracticeScenario,
  OnDemandPracticeFeedbackOverview,
  OnDemandPracticeOverview,
  OnDemandPracticeAttempts,
  OnDemandPracticeEditor,
  OnDemandPracticeRequestFeedback,
  OnDemandPracticeFeedbackGiving,
  OpenDownload,
  Pagination,
  PartnerFeedbackReportMobile,
  PartnerFeedbackReportDesktop,
  PartnerFeedbackRoot,
  PartnerFeedbackWrapper,
  PartnerFeedbackSummaryRoot,
  PasswordChange,
  PathBuilder,
  PeopleAdvancedRoot,
  PracticeQuestion,
  PracticeQuestionInsights,
  Progress,
  ProgressBar,
  QuestionDetails,
  QuestionPrompt,
  QuestionElementPrompt,
  RadialProgress,
  ReminderModal,
  RepeatablePracticeQuestion,
  ResetPassword,
  Reveal,
  Roles,
  RolePlay,
  SalesforceIntegrationSettings,
  SaveLessonAsTemplate,
  ScormCopyContentModal,
  ScormMultipleDownload,
  ScreenRecordingQuestion,
  SeismicContent,
  SettingsAccountExpert: Settings.AccountExpert,
  SettingsCustomization,
  SettingsReportCardHeader,
  SettingsZoomIntegration: Settings.SettingsZoomIntegration,
  SharableRecordingLinkContainer,
  ShareToCompany,
  SortingQuestion,
  TagImage,
  TagsIndex,
  TaskBuilder,
  TemplateGalleryRoot,
  TextView,
  TicketHandlingPracticeQuestion,
  TriggerBuilder,
  TriggersContainer,
  UploadResponseQuestion,
  VideoResponse,
  VideoResponseQuestion,
  VideoThumbnail,
  WorkspacesIndex,
  ZendeskIntegrationSettings,
  ZendeskPracticeQuestion,
  AssignmentIncomplete,
  UserProgress,
};

// Registering components under the development environment
if (process.env.NODE_ENV === 'development') {
  // eslint-disable-next-line
  components.UIPlayground = require('./components/UIPlayground').default;
}

// Register page components to be used in erb views `react_component(`
Object.keys(pageComponents).forEach(component => {
  ReactOnRails.register({
    [component]: withPage(pageComponents[component], component),
  });
});

// Register components to be used in erb views `react_component(`
Object.keys(components).forEach(component => {
  ReactOnRails.register({
    [component]: withModule(components[component], component),
  });
});
